import styled from 'styled-components';
const CardContainer = styled.div `
  width: 100%;
`;
export const Styled = {
    CardContainer,
};
//# sourceMappingURL=CarouselWrapper.styles.js.map